<template>
  <iframe
    :src="getUrl(media)"
    title="Advertisement"
    ref="frame"
    @load="onLoad"
    @error="error"
  />
</template>

<script>
import AdMediaController from '@/components/playlist/ad-media-playlist/ad-media-controller'
import AdItem from '@/app/service/api/model/ad/ad-item-type/ad-item'

export default {
  name: 'AdHtml',
  mixins: [AdMediaController],
  props: {
    media: {
      type: AdItem,
      required: true
    }
  },
  data () {
    return {
      htmlTimeout: null
    }
  },
  computed: {
    htmlDuration () {
      return this.media.getDuration() * 1000
    }
  },
  methods: {
    onLoad () {
      this.successLoad()
      clearTimeout(this.htmlTimeout)
      this.htmlTimeout = setTimeout(() => this.ended(), this.htmlDuration)
    }
  },
  beforeDestroy () {
    clearTimeout(this.htmlTimeout)
  }
}
</script>

<style>
.add-contents .content iframe.horizontal,
.add-contents .content iframe.vertical {
    width: 100%;
    height: 100%;
    border: 0;
}
</style>
